import React, { ChangeEvent, FC } from 'react';
import { HeaderModel } from '../../../models/CommonModel';
import SortableColumn from '../../../components/Table/SortableColumn';
import { formatPrice, revertPriceNumner } from '../../../selectors';
import { PayrollRowModel } from '../../../models/account-books/PayrollAccount';
import { calcSocialInsurance } from '../../../modules/common/helper';
import { NumericFormat } from 'react-number-format';

type Props = {
    month: number
    data: Array<PayrollRowModel>,
    defaultWorkDays: number,
    header: HeaderModel[]
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void,
    handleSetWorkDays: (e: ChangeEvent<HTMLInputElement>, id: number) => void,
    handleUpdate: (id: number) => void,
    handleSetInsurance: (id: number, value: number, type: string) => void
}

const PayrollAccountTable: FC<Props> = ({ 
    month,
    data, 
    defaultWorkDays, 
    header, 
    hideCols, 
    openColConfig, 
    handleSort, 
    handleSetWorkDays,
    handleUpdate,
    handleSetInsurance
}) => {

    const renderStatus = (status: string) => {
        switch (status) {
			case 'paid':
				return 'Đã thanh toán';
			case 'unpaid':
				return 'Chưa thanh toán';
			default:
				return 'Chưa thanh toán';
		}
    }
    
    return (
        <div className='table-responsive'>
            <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
                <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                        <th>
                            <i 
                                className="fa fa-cogs"
                                style={{cursor: 'pointer'}}
                                onClick={openColConfig}
                            ></i>
                        </th>
                        {header.map((th, index) => {
                            if (!hideCols.includes(th.field)) {
                                if (th.sortable) {
                                    return (
                                        <SortableColumn
                                            key={'th-' + index}
                                            sortBy={th?.field}
                                            onSortChange={handleSort}
                                            style={th?.style ?? {}}
                                        >
                                            {th.label}
                                        </SortableColumn>
                                    )
                                }
                                return (
                                    <th style={th?.style ?? {}}>{th.label}</th>
                                )
                            }
                        })}
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item: PayrollRowModel, index: number) => {
                        let workDays = item?.cur_payroll?.work_days ?? defaultWorkDays;
                        let cost = item?.cur_payroll?.cost ?? item.day_cost;
                        let salary = (item?.cur_payroll?.salary ?? 0) ?? cost * workDays; 
                        let actualReceived = item?.cur_payroll?.actual_received;
                        let sInsurance = item?.cur_payroll?.social_insurance ?? 0;
                        let hInsurance = item?.cur_payroll?.health_insurance ?? 0;
                        let uInsurance = item?.cur_payroll?.unemployment_insurance ?? 0;
                        return (
                            <tr key={`payroll_${index}_${month}`} className="cursor-pointer">
                                <td>
                                    <button onClick={() => handleUpdate(item.id)}
                                        className='btn btn-icon btn-success btn-sm ms-1 me-1'>
                                        <i className='fas fa-save'></i>
                                    </button>
                                </td>
                                {!hideCols.includes('name') && (
                                <td>
                                    {item.name}
                                </td>
                                )}
                                {!hideCols.includes('work_days') && (
                                <td>
                                    <input
                                        id='fromPrice'
                                        name='from_price'
                                        type='number'
                                        className='form-control'
                                        onChange={(e) => handleSetWorkDays(e, item.id)}
                                        value={workDays}
                                    />
                                </td>
                                )}
                                {!hideCols.includes('cost') && (
                                <td>{formatPrice(cost)}</td>
                                )}
                                {!hideCols.includes('salary') && (
                                <td >{formatPrice(salary)}</td>
                                )}
                                {!hideCols.includes('social_insurance') && (
                                <td>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='social_insurance'
                                        className='form-control form-control-sm'
                                        value={sInsurance}
                                        onBlur={(e) => {
                                            handleSetInsurance(item.id, revertPriceNumner(e.target.value), 'social_insurance');
                                        }}
                                    />
                                </td>
                                )}
                                {!hideCols.includes('health_insurance') && (
                                <td>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='health_insurance'
                                        className='form-control form-control-sm'
                                        value={hInsurance}
                                        onBlur={(e) => {
                                            handleSetInsurance(item.id, revertPriceNumner(e.target.value), 'health_insurance');
                                        }}
                                    />
                                </td>
                                )}
                                {!hideCols.includes('unemployment_insurance') && (
                                <td>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='unemployment_insurance'
                                        className='form-control form-control-sm'
                                        value={uInsurance}
                                        onBlur={(e) => {
                                            handleSetInsurance(item.id, revertPriceNumner(e.target.value), 'unemployment_insurance');
                                        }}
                                    />
                                </td>
                                )}
                                {!hideCols.includes('actual_received') && (
                                <td>
                                    {formatPrice(actualReceived)}
                                </td>
                                )}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default PayrollAccountTable;